import { render, staticRenderFns } from "./estimate-item-comment-icons.vue?vue&type=template&id=5d73ed18&scoped=true"
import script from "./estimate-item-comment-icons.vue?vue&type=script&lang=js"
export * from "./estimate-item-comment-icons.vue?vue&type=script&lang=js"
import style0 from "./estimate-item-comment-icons.vue?vue&type=style&index=0&id=5d73ed18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73ed18",
  null
  
)

export default component.exports